import { mergeSxProps } from "@clipboard-health/ui-components";
import { Box, type BoxProps } from "@mui/material";

// FIXME: Automatically disabled during ESLint config update
export interface CalendarGridSectionWrapperProps extends BoxProps {}

export function CalendarGridSectionWrapper(props: CalendarGridSectionWrapperProps) {
  const { sx, ...restProps } = props;

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          rowGap: 3,
        },
        sx
      )}
      {...restProps}
    />
  );
}
